
export default {
  name: 'Sales',
  head() {
    const title = 'Latest KUSAMA Sales'
    const metaData = {
      title,
      type: 'profile',
      description: 'Featuring the most recently sold NFTs on RMRK.',
      url: './sales.vue',
      image: `${this.$config.public.baseUrl}/k_card.png`,
    }
    return {
      title,
      meta: [...this.$seoMeta(metaData)],
    }
  },
}
